import MovimientosDashboardTable from 'components/tables/MovimientosDashboardTable';
import React from 'react';

// Define the interface for props
interface MovimientosDashboardProps {
  procRows: ProcRow[];
}

// Define the interface for each row in procRows
interface ProcRow {
  id: number;
  descripcion: string;
  time: string;
  proc: string;
  caratula: string;
  usuario: string;
}

const MovimientosDashboard: React.FC<MovimientosDashboardProps> = ({ procRows }) => {
  return (
    <>
      <MovimientosDashboardTable procRows={procRows} />
    </>
  );
};

export default MovimientosDashboard;

